(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('TypeContactFacilityType', TypeContactFacilityType);

    TypeContactFacilityType.$inject = ['$resource'];

    function TypeContactFacilityType ($resource) {
        var resourceUrl =  'api/type-contact-facility-types/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByCorporation': {url: 'api/type-contact-facility-types/by-corporation/:id', method: 'GET', isArray: true}
        });
    }
})();
